import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import FuelingContractsSection from "./sections/FuelingContractsSection";
import FuelingContractDetailPage from "./pages/fueling/FuelingContractDetailPage";

type Props = {}

const FuelingContracts = (props: Props) => {
  let match = useRouteMatch();

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/:fuelingContractId`} component={FuelingContractDetailPage} />
      <Route path={match.path}>
        <Header title={t("fuelingContracts.title")} includeBreadcrumbs />
        <ModuleContent>
          <FuelingContractsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
}

export default FuelingContracts;